export default __webpack_public_path__ + "static/media/sv_11.f7ace205.webp";